<template>
  <ModalItem position="top-right" @close="close">
    <template #body>
      <div>
        <div class="profile-header">
          <ProfileInitials :size="36" />
          <div class="user-info-container">
            <p class="username">
              {{ userStore.currentUser?.name }}
            </p>
            <p class="email">
              {{ userStore.currentUser?.email }}
            </p>
          </div>
        </div>

        <div class="profile-modal-button" @click="navigateToProfile">
          <ProfileIcon class="profile-modal-icon" />
          <p class="menu-title">
            {{ $t('profile.navigate') }}
          </p>
        </div>

        <div class="profile-modal-button">
          <LanguageIcon class="profile-modal-icon" />
          <p class="menu-title">
            {{ $t('profile.language') }}
          </p>
          <SortDropdownItem
            :title="languageOptions.find((option) => option.value === userStore.locale)?.label"
            :options="languageOptions"
            :selected-option="languageOptions.find((option) => option.value === userStore.locale) || languageOptions[0]"
            :select="changeLanguage"
            class="dropdown" />
        </div>

        <div class="profile-modal-button" @click="logout">
          <LogoutIcon class="profile-modal-icon" />
          <p class="menu-title">
            {{ $t('profile.disconnect') }}
          </p>
        </div>

        <div class="profile-modal-button changelog-button" @click="openChangelog">
          <InfoIcon class="profile-modal-icon" />
          <p class="menu-title">{{ $t('changelog.nav-label') }}</p>
          <span v-if="changelogUnread" class="unread-dot" />
        </div>

        <div class="profile-modal-button">
          <p class="version-number">Version: {{ appVersion }}</p>
        </div>
      </div>
    </template>
  </ModalItem>
</template>

<script>
import ModalItem from '@/components/general/ModalItem.vue';
import ProfileInitials from '@/components/general/Profile/ProfileInitials.vue';
import ProfileIcon from '@/assets/icons/ProfileIcon.vue';
import LogoutIcon from '@/assets/icons/LogoutIcon.vue';
import { useUserStore } from '@/store/userStore';
import LanguageIcon from '@/assets/icons/LanguageIcon.vue';
import InfoIcon from '@/assets/icons/InfoIcon.vue';
import SortDropdownItem from '../SortDropdownItem.vue';

export default {
  name: 'ProfileModal',
  components: {
    ModalItem,
    ProfileInitials,
    ProfileIcon,
    LogoutIcon,
    LanguageIcon,
    InfoIcon,
    SortDropdownItem,
  },
  props: {
    changelogUnread: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'open-changelog'],
  setup() {
    const userStore = useUserStore();
    return { userStore, appVersion: process.env.VUE_APP_VERSION };
  },
  data() {
    return {
      languageOptions: [
        { value: 'en', label: 'English' },
        { value: 'fr', label: 'Français' },
      ],
    };
  },
  methods: {
    navigateToProfile() {
      this.userStore.editProfile();
      this.close();
    },
    logout() {
      this.userStore.keycloak.logout();
    },
    close() {
      this.$emit('close');
    },
    openChangelog() {
      this.$emit('open-changelog');
      this.close();
    },
    changeLanguage(option) {
      this.$i18n.locale = option.value;
      this.userStore.setLanguage(option.value);
    },
  },
};
</script>

<style scoped>
.profile-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.user-info-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 42px;
}

.username {
  font-weight: bold;
  margin: 0;
}

.email {
  margin: 0;
  font-size: 0.9em;
  color: var(--text-tertiary);
}

.profile-modal-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 10px;
  width: 100%;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s ease;
}

.menu-title {
  margin: 0;
  font-size: 1em;
  color: var(--text-tertiary);
}

.profile-modal-icon {
  color: var(--text-tertiary);
  width: 15px;
  height: 15px;
}

.dropdown {
  background-color: var(--button-background);
  border-radius: 25px;
  padding: 5px 10px;
  color: var(--text);
}

.unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--info);
  flex-shrink: 0;
}

.version-number {
  color: var(--text-tertiary);
  font-size: 14px;
  text-align: end;
  width: 100%;
}
</style>
